import Vue from "vue";
import * as filters from "./filters";
import { errors } from "./errors";
import directives from "./directives";
import * as injectables from './injectables'

/**
 * @description injects all the filter in the vue instance globally
 */
export const injectFilters = () => {
  for (const key in filters) {
    Vue.filter(key, filters[key]);
  }
};

export const injectInjectables = () => {
  //let vue = Vue;

  /**
   * Checks the NODE_ENV to be test and then injects injectables in the vue instance of the component
   * which is passed as a param to the function. So that test cases for that component runs successfully.
   */
  // if (vueInstance && isTestEnv()) {
  //   vue = vueInstance;
  // }

  // Iterate and injects all the injectables
  //for (const key in injectablesObj) {
  Vue.prototype[`$errors`] = errors;
  //}
  for (const key in injectables) {
    Vue.prototype[`$${key}`] = injectables[key];
  }
};

/**
 * Registers directives globally in the project
 */
export const registerDirectives = () => {
  for (const key in directives) {
    Vue.directive(key, directives[key]);
  }
};

/**
 * upperCaseFirst
 * @description capitalize the first letter of a word
 * @return {String}
 */
export const upperCaseFirst = (str) => {
  return str ? str.replace(/^\w/, (c) => c.toUpperCase()) : "";
};

export const lowerCaseFirst = (str) => {
  return str ? str.replace(/^\w/, (c) => c.toLowerCase()) : "";
};
